import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const SimplePrice = (props) => {

    const { simpleProduct, setSimpleProduct, productPrices, setProductPrices } = props;

    const { api, userData, settingData, categoryData, vatGroupData, selectedCompany, accountData,
        productData, refData, branchData, projectData, currencyData, formLanguages } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    // Account Options
    const accountOptions = accountData?.map(item => ({
        value: item.id,
        label: `${item.chartId}.${item.accountId} ${item.name}`,
        name: item.name,
    }));




    // Add VarientRow
    const handleAddRow = () => {
        setProductPrices([...productPrices, { name: '', raiseBy: 0, price: 0, productId: idRow?.id }]);
    };

    // Delete VarientRow
    const handleDeleteRow = (event) => {
        event.preventDefault()
        if (productPrices.length > 0) {
            const updatedRows = productPrices.slice(0, -1);
            setProductPrices(updatedRows);
        } else {
            toast.error('you need at least one variant')
        }
    };

    // handle select change
    const handleSelectChange = (selectedOption, name) => {
        setSimpleProduct((prev) => ({
            ...prev,
            [name]: selectedOption.value,
        }));
    };


    // Change Unit Array
    const handlePriceChange = (index, e) => {
        const updatedPrices = [...productPrices];
        const value = e.target.value;
        const name = e.target.name;

        if (name == 'name') {
            updatedPrices[index].name = value;
        }
        else if (name == 'price') {
            updatedPrices[index].price = value;
        }

        setProductPrices(updatedPrices);
    }



    return (

        <div>

            {productPrices.map((row, index) => (
                <div key={index}>
                    {/* Render the labels only for the first row */}
                    {index === 0 && (
                        <Row className="mb-3">
                            <Form.Group as={Col}>
                                <Form.Label>{formLanguages.Name}</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>{formLanguages.Price}</Form.Label>
                            </Form.Group>
                        </Row>
                    )}

                    <Row className="mb-3" style={{ marginTop: '-20px' }}>

                        <Form.Group as={Col}>
                            <Form.Control type="text" name="name"
                                onChange={(e) => handlePriceChange(index, e)}
                                value={row.name}
                                required />
                        </Form.Group>

                        <Form.Group as={Col}>
                            <Form.Control type="number" step="any" name="price"
                                onChange={(e) => handlePriceChange(index, e)}
                                value={row.price}
                                required />
                        </Form.Group>



                    </Row>

                    <Row key={index + 100} className="mb-3">

                    </Row>
                </div>
            ))}

            <Form.Group
                as={Col}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={handleAddRow} />
                <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e)} />
            </Form.Group>
        </div>

    )
}


export default SimplePrice;